var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F2F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6672 16.3328C10.8901 16.5557 11.2516 16.5557 11.4745 16.3328L14.2106 13.5967L16.9467 16.3328C17.1696 16.5557 17.5311 16.5557 17.754 16.3328C17.9769 16.1099 17.9769 15.7484 17.754 15.5255L15.0179 12.7894C14.572 12.3435 13.8491 12.3435 13.4033 12.7894L10.6672 15.5255C10.4443 15.7484 10.4443 16.1099 10.6672 16.3328Z",
    fill: "#1A1C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircle);
export default __webpack_public_path__ + "static/media/arrow-up-circle.020b59d5ab5b5d82c56cc7a4efd5addf.svg";
export { ForwardRef as ReactComponent };